import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  connect() {
    this.initializeTooltips()
  }

  disconnect() {
    this.disposeTooltips()
  }

  initializeTooltips() {
    const tooltipTriggerList = this.element.querySelectorAll('[data-bs-toggle="tooltip"]')
    this.tooltips = [...tooltipTriggerList].map(el => new Tooltip(el))
  }

  disposeTooltips() {
    if (this.tooltips) {
      this.tooltips.forEach(tooltip => tooltip.dispose())
    }
  }
}
